/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListSupportArticlesRequest} from '@cash-web/protos/squareup/cash/supportarticles/app/v1beta1/app.pb'
import {ListSupportArticlesResponse} from '@cash-web/protos/squareup/cash/supportarticles/app/v1beta1/app.pb'


export const listSupportArticles = (request:ListSupportArticlesRequest, options?: CashRequestOptions) => post<ListSupportArticlesRequest, ListSupportArticlesResponse>("/cash-app/support-articles/v1/list", request, {...options, rejectOnError: true })